// extracted by mini-css-extract-plugin
export default {"button":"FormButton_button__qFTFo","disabled":"FormButton_disabled__6apVh","subtext":"FormButton_subtext__VrnOA"};